/**
 * External imports
 */

import { faUserPoliceTie } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Container, Grid, SxProps, Typography, Button } from "@mui/material";
import * as React from "react";
import ToggleFeedbackButton from "../buttons/ToggleFeedbackButton";
import AppSettingsContext from "@/contexts/AppSettingsContext";

/**
 * Internal imports
 */

const body: SxProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100%',
    textAlign: 'center'
}



const ForbiddenPage: React.FunctionComponent = () => {
    const appSettingsResponse = React.useContext(AppSettingsContext);
    const sentrySettings = appSettingsResponse?.data?.sentrySettings;

    const additionalHeaderComponents = React.useMemo(() => {
        return (
            sentrySettings?.dsn &&
            sentrySettings?.enableReportABug ?
                [<ToggleFeedbackButton />] :
                undefined
        );
    }, [sentrySettings]);


    return (
        <Container
            maxWidth="lg"
        >
            <Box
                sx={{...body,}}
            >
                <Grid 
                    sx={{...body,}}
                    container
                >
                    <Grid item>
                        <Typography
                            variant="h1"                            
                            gutterBottom
                        >
                            <FontAwesomeIcon icon={faUserPoliceTie}/>&emsp;<b>Access&nbsp;Denied</b>&emsp;<FontAwesomeIcon icon={faUserPoliceTie} />
                        </Typography>
                        <Typography
                            variant="h2"
                            gutterBottom
                        >
                            You do not have permission to view this page.
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{marginTop: '20px'}}
                            onClick={() => {
                                window.location.href = '/';
                            }}
                        >
                            Return Home
                        </Button>
                    </Grid>
                    
                </Grid>
                
            </Box>
            {additionalHeaderComponents}
        </Container>
    ) 
}

export default ForbiddenPage